export const PermissionsList = [
    { label: '/v2/access_group/GET', value: 'getAccessGroups' },
    { label: '/v2/access_group/POST', value: 'saveAccessGroup' },
    { label: '/v2/access_group/{}/GET', value: 'getAccessGroup' },
    { label: '/v2/access_group/{}/PUT', value: 'editAccessGroup' },
    { label: '/v2/access_group/{}/PUT', value: 'deleteAccessGroup' },
    { label: '/v2/locations/POST', value: 'addLocation' },
    { label: '/v2/locations/{}/PUT', value: 'updateLocation' },
    { label: '/v2/locations/{}/PUT', value: 'deleteLocation' },
    { label: '/v2/locations/{}/connector/GET', value: 'getLocationConnector' },
    { label: '/v2/locations/{}/GET', value: 'getLocation' },
    { label: '/v2/connectors/POST', value: 'saveConnector' },
    { label: '/v2/connectors/{}/GET', value: 'getConnector' },
    { label: '/v2/connectors/GET', value: 'getConnectors' },
    { label: '/v2/connectors/{}/PUT', value: 'updateConnector' },
    { label: '/v2/connectors/{}/PUT', value: 'deleteConnector' },
    { label: '/v2/connectors/{}/logfile/GET', value: 'getConnectorLogs' },
    { label: '/v2/users/invite-user/PUT', value: 'inviteUser' },
    { label: '/v1/location_sales/GET', value: 'getSales' },
    { label: '/v2/users/POST', value: 'addUser' },
    { label: '/v2/switch/user/{}/POST', value: 'switchUser' },
    { label: '/v2/switch/user/{}/across/POST', value: 'switchUserAcrossCompany' },
    { label: '/v2/users/GET', value: 'getUsers' },
    { label: '/v2/users/company/{}/GET', value: 'getCompanyUsers' },
    { label: '/v2/users/{}/PUT', value: 'updateUser' },
    { label: '/v2/users/{}/PUT', value: 'deleteUser' },
    { label: '/v2/users/reset/connector/{}/credential/PUT', value: 'resetPassword' },
    { label: '/v2/company/department/group/POST', value: 'addDepartment' },
    { label: '/v2/company/department_group/{}/PUT', value: 'updateDepartment' },
    { label: '/v2/departments/{}/DELETE', value: 'deleteDepartment' },
    { label: '/v2/company/{}/GET', value: 'getCompany' },
    { label: '/v2/company/POST', value: 'saveCompany' },
    { label: '/v2/company/{}/PUT', value: 'updateCompany' },
    { label: '/v2/company/{}/PUT', value: 'deleteCompany' },
    { label: '/v2/company/GET', value: 'getCompanies' },
    { label: '/v2/roles/{}/GET', value: 'getRoles' },
    { label: '/v2/roles/POST', value: 'addRole' },
    { label: '/v2/roles/PUT', value: 'updateRole' },
    { label: '/v2/access_group/{}/PUT', value: 'updateAccessGroup' },
    { label: '/v1/permissions/GET', value: 'getPermissions' },
    { label: '/v2/file/company-logo/GET', value: 'getCompanyLogo' },
    { label: '/v2/file/company-logo/DELETE', value: 'deleteCompanyLogo' },
    { label: '/v2/file/company-logo/PUT', value: 'updateCompanyLogo' },
    { label: '/location/list-report-pdf/GET', value: 'getReports' },
    { label: '/v2/previous_basket_analysis_query/GET', value: 'getAnalytics' },
    { label: '/v2/company/user/{}/PUT', value: 'updateUserAcrossCompany' },
];

